export default __webpack_public_path__ + "static/MediaContentOne-1c82265f2e37c8d4f2354604e6f2611b.webp";